import request from "@/api";
import type { CustomAxiosRequestConfig } from "@/api";
import { BaseService } from "./baseService";
import type { BaseEntityWithLongId } from "@zhihaoscm/entity";

export class CustomColumnService extends BaseService<unknown, unknown, unknown, unknown> {
    // 保存用户自定义列表字段
    public async save(params: { businessType: number; columnConfig: string }): Promise<void> {
        const { data } = await this.service.post(`${this.path}/save`, params, {
            loading: false
        } as CustomAxiosRequestConfig);
        return data;
    }

    // 获取用户自定义列表字段
    public async query(params: { businessType: number }): Promise<
        {
            businessType?: number;
            columnConfig?: string;
            userId?: number;
        } & BaseEntityWithLongId
    > {
        const { data } = await this.service.get(`${this.path}/query`, { params });
        return data;
    }
}

export const customColumnService = new CustomColumnService("/admin/custom-column", request.service);
